import { StateProps } from 'Container/App/interface';
import {
    createOptionPicker,
    OptionPicker,
} from '@vfde-brix/ws10/option-picker';
import {
    TrackingProductType,
    trackIt,
    TrackToggleOption,
    TrackType,
} from '@vfde-sails/tracking';
import { getRlzDiscountSoc } from '@vfde-sails/page-options';
import {
    selectCustomerConfig,
    selectIsEligibleForRestlaufzeit,
    setRestlaufzeit,
} from 'Container/App/slice';
import { useDispatch } from '../store';
import { startAppListening } from 'Container/App/listener';
import { createComponentById } from '@vfde-brix/ws10/core';
import { RESTLAUFZEIT_OPTION_PICKER_CONTAINER } from 'Container/App/constants';

const mountRestlaufzeitOptionPicker = () => {
    const dispatch = useDispatch();

    const onChange = (event: Event) => {
        const target = event.target as HTMLInputElement;

        const trackingDataKey = target.value === 'true' ? TrackToggleOption.Selected : TrackToggleOption.Removed;

        trackIt(TrackType.SwitchOptions, {
            [trackingDataKey]: [{
                name: 'Wechselbonus Restlaufzeitbefreiung bis 6 Monate',
                type: TrackingProductType.Discount,
                sku: getRlzDiscountSoc(),
                proposition: 1,
            }],
        });

        dispatch(setRestlaufzeit(
            target.value === 'true',
        ));
    };

    const restlaufzeitPicker = createComponentById(createOptionPicker, RESTLAUFZEIT_OPTION_PICKER_CONTAINER, { onChange });

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectIsEligibleForRestlaufzeit(currentState) !== selectIsEligibleForRestlaufzeit(previousState),
        effect: (_action, api) => {
            api.cancelActiveListeners();

            const isEligibleForRestlaufzeit = selectIsEligibleForRestlaufzeit(api.getState());

            restlaufzeitPicker?.toggleContainer(!isEligibleForRestlaufzeit);
        },
    });

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectCustomerConfig(currentState).isRestlaufzeit !== selectCustomerConfig(previousState).isRestlaufzeit,
        effect: (_action, api) => {
            api.cancelActiveListeners();

            const customerConfig = selectCustomerConfig(api.getState());

            restlaufzeitPicker && updateRlzCheckedState(restlaufzeitPicker, customerConfig);
        },
    });

    return restlaufzeitPicker;
};

/**
 * Update checked state after selecting RLZ
 */
export const updateRlzCheckedState = (optionPicker: OptionPicker, { isRestlaufzeit }: StateProps['customerConfig']): void => {
    const { items } = optionPicker.getProperties();

    items.forEach(item => {
        switch (item.stdValue) {
            case 'true':
                item.optChecked = isRestlaufzeit;
                break;
            case 'false':
                item.optChecked = !isRestlaufzeit;
                break;
        }
    });

    optionPicker.update({ items });
};

export default mountRestlaufzeitOptionPicker;
